import React, { Suspense } from "react";
import { SuspenseWithErrorBoundry } from "../layout/suspense/SuspenseWithErrorBoundry";
import { SuspenseFallback } from "../layout/suspense/SuspenseFallback";
import { ErrorBoundryFallback } from "../layout/suspense/ErrorBoundryFallback";

interface LazyRouteElementProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}
export const LazyRouteElement: React.FC<LazyRouteElementProps> = ({ children, fallback }) => {
    if (!children) return null;
    return (
        <SuspenseWithErrorBoundry
            suspenseFallback={fallback ? <Suspense fallback={fallback} /> : <SuspenseFallback />}
            errorBoundryFallback={<ErrorBoundryFallback mode="text" text="Kunne ikke laste inn siden..." />}
        >
            {children}
        </SuspenseWithErrorBoundry>
    );
};
